import { Photo, Section, SectionHeading } from "@/components/ui";
import { ABOUT_GAP } from "@/data/about";
import { PHOTOS } from "@/data/photos";

/** Why A Learning Lab exists: the gap between choosing a path and experiencing it. */
export function AboutGapSection() {
  return (
    <Section labelledBy="about-gap-title" testId="about-gap">
      <div className="relative z-10 grid items-center gap-8 lg:grid-cols-12 lg:gap-14">
        <div className="lg:col-span-7">
          <SectionHeading id="about-gap-title" title={ABOUT_GAP.title} highlight="worth closing" />
          <div className="mt-6 space-y-4 text-base text-ink/80 sm:text-lg">
            {ABOUT_GAP.paragraphs.map((text) => (
              <p key={text} className="max-w-[60ch]">
                {text}
              </p>
            ))}
          </div>
        </div>
        <div className="mx-auto w-full max-w-sm lg:col-span-5 lg:max-w-none">
          <Photo photo={PHOTOS.campus} ratio="aspect-[1/1]" sizes="(min-width: 1024px) 40vw, 90vw" testId="about-gap-photo" />
        </div>
      </div>
    </Section>
  );
}
